import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface UserStore {
  user: {
    email: string;
    isAdmin: boolean;
    id: string;
  } | null;
}

export const initialState: UserStore = {
  user: null,
};

const slice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setUserData: (
      state,
      {
        payload,
      }: PayloadAction<{ email: string; id: string; isAdmin: boolean }>
    ) => {
      state.user = payload;
    },
  },
});

export const { setUserData } = slice.actions;

export default slice.reducer;
